import React, { useState } from 'react';
import SubNavbar from '../../components/SubNavbar';
import ContactBox from '../../components/ContactBox';
import PhotoModal from '../../components/PhotoModal';

const ItalyGreece = () => {
  const [modalImage, setModalImage] = useState(null);
  const [modalAlt, setModalAlt] = useState('');

  const openModal = (imageSrc, imageAlt) => {
    setModalImage(imageSrc);
    setModalAlt(imageAlt);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAlt('');
  };

  return (
    <div className="white-page">
      <SubNavbar />      
      <div className="photography-subpage-content">
        <div className="photos-container">
          <div className="photo-grid">
          <div className="photo-item">
              <img 
                src="/photos/AF08960-R1-08-12.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R1-08-12.JPG", "AF08960-R1-08-12")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item large">
              <img 
                src="/photos/LAF08960-R1-06-10.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R1-06-10.JPG", "LAF08960-R1-06-10")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/AF08960-R1-10-14.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R1-10-14.JPG", "AF08960-R1-10-14")}
                style={{ cursor: 'pointer' }}
              />
            </div>


            <div className="photo-item large">
              <img 
                src="/photos/LAF08960-R2-36-37.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-36-37.JPG", "LAF08960-R2-36-37")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/AF08960-R1-11-15.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R1-11-15.JPG", "AF08960-R1-11-15")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/AF08960-R1-19-23.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R1-19-23.JPG", "AF08960-R1-19-23")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item tall">
              <img 
                src="/photos/AF08960-R2-24-25.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R2-24-25.JPG", "AF08960-R2-24-25")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item large">
              <img 
                src="/photos/LAF08960-R2-14-15.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-14-15.JPG", "LAF08960-R2-14-15")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/AF08960-R1-25-29.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R1-25-29.JPG", "AF08960-R1-25-29")}
                style={{ cursor: 'pointer' }}
              />
            </div>    
            <div className="photo-item large">
              <img 
                src="/photos/LAF08960-R2-32-33.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-32-33.JPG", "LAF08960-R2-32-33")}
                style={{ cursor: 'pointer' }}
              />
            </div>        
            
            <div className="photo-item">
              <img 
                src="/photos/AF08960-R1-27-31.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R1-27-31.JPG", "AF08960-R1-27-31")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/AF08960-R2-08-9.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R2-08-9.JPG", "AF08960-R2-08-9")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/AF08960-R2-15-16.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R2-15-16.JPG", "AF08960-R2-15-16")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/AF08960-R2-22-23.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R2-22-23.JPG", "AF08960-R2-22-23")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/AF08960-R2-26-27.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/AF08960-R2-26-27.JPG", "AF08960-R2-26-27")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item large">
              <img 
                src="/photos/LAF08960-R2-31-32.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-31-32.JPG", "LAF08960-R2-31-32")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/LAF08960-R2-11-12.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-11-12.JPG", "LAF08960-R2-11-12")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item large">
              <img 
                src="/photos/LAF08960-R2-14-15.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-14-15.JPG", "LAF08960-R2-14-15")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/LAF08960-R2-34-35.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/LAF08960-R2-34-35.JPG", "LAF08960-R2-34-35")}
                style={{ cursor: 'pointer' }}
              />
            </div>

          </div>
        </div>
      </div>
      <PhotoModal 
        isOpen={modalImage !== null}
        imageSrc={modalImage}
        imageAlt={modalAlt}
        onClose={closeModal}
      />
    </div>
  );
};

export default ItalyGreece;
